/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ExclusaoBeneficiarioAliases {
  ATTACHMENTS_LIST = 'attachments-list',
  AUTOCOMPLETE_CIDADE = 'autocomplete-cidade',
  AUTOCOMPLETE_MOTIVO_EXCLUSAO = 'autocomplete-motivo-exclusao',
  CARD_0 = 'card-0',
  CHECKBOX_APOSENTOU_EMPRESA = 'checkbox-aposentou-empresa',
  CHECKBOX_MENSALIDADE_PLANO = 'checkbox-mensalidade-plano',
  CHECKBOX_REENVIO_ANEXO = 'checkbox-reenvio-anexo',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DATE_DT_CONCESAO = 'date-dt-concesao',
  DATE_FIELD_DT_OBITO = 'date-field-dt-obito',
  DATE_FIELD_DT_RESCISAO = 'date-field-dt-rescisao',
  DATE_FIELD_DT_SOLICITACAO = 'date-field-dt-solicitacao',
  FETCH_CIDADE = 'fetch-cidade',
  FETCH_ESTADO = 'fetch-estado',
  FETCH_MOTIVO_EXCLUSAO = 'fetch-motivo-exclusao',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_3 = 'field-3',
  FIELD_ANEXO = 'field-anexo',
  FIELD_APOSENTOU_EMPRESA = 'field-aposentou-empresa',
  FIELD_BAIRRO = 'field-bairro',
  FIELD_BENEFICIARIOS = 'field-beneficiarios',
  FIELD_CELULAR = 'field-celular',
  FIELD_CEP = 'field-cep',
  FIELD_CERTIDAO_OBITO = 'field-certidao-obito',
  FIELD_CIDADE = 'field-cidade',
  FIELD_COMPLEMENTO = 'field-complemento',
  FIELD_DT_CONCESAO = 'field-dt-concesao',
  FIELD_DT_OBITO = 'field-dt-obito',
  FIELD_DT_RESCISAO_DATE_FIELD = 'field-dt-rescisao-date-field',
  FIELD_DT_RESCISAO_INPUT = 'field-dt-rescisao-input',
  FIELD_DT_SOLICITACAO = 'field-dt-solicitacao',
  FIELD_EMAIL = 'field-email',
  FIELD_ENDERECO = 'field-endereco',
  FIELD_ESTADO = 'field-estado',
  FIELD_FORMA_CONTATO = 'field-forma-contato',
  FIELD_LIST = 'field-list',
  FIELD_LIST_0 = 'field-list-0',
  FIELD_LIST_BENEFICIARIOS = 'field-list-beneficiarios',
  FIELD_MENSALIDADE_PLANO = 'field-mensalidade-plano',
  FIELD_MOTIVO_EXCLUSAO = 'field-motivo-exclusao',
  FIELD_MOTIVO_REJEICAO = 'field-motivo-rejeicao',
  FIELD_NUMERO = 'field-numero',
  FIELD_OBSERVACAO = 'field-observacao',
  FIELD_OBSERVACAO_REJEICAO = 'field-observacao-rejeicao',
  FIELD_REENVIO_ANEXO = 'field-reenvio-anexo',
  FIELD_TELEFONE = 'field-telefone',
  FIELD_TEMPO_CONTRIBUICAO = 'field-tempo-contribuicao',
  FIELD_TITULAR = 'field-titular',
  FIELD_TOAST = 'field-toast',
  FIELDSET_EMAIL = 'fieldset-email',
  FIELDSET_ENDERECO = 'fieldset-endereco',
  FILE_UPLOADER_ANEXO = 'file-uploader-anexo',
  FORM_ANEXO = 'form-anexo',
  FORM_COMPLEMENTAR = 'form-complementar',
  FORM_CONTATO = 'form-contato',
  FORM_OBITO = 'form-obito',
  FORM_REENVIO_SOLICITACAO = 'form-reenvio-solicitacao',
  FORM_RESCISAO = 'form-rescisao',
  FORM_SITUACAO_TRABALHISTA = 'form-situacao-trabalhista',
  HPMS_CUSTOM_FIELD_LIST_BENEFICIARIOS = 'hpms-custom-field-list-beneficiarios',
  INPUT_BAIRRO = 'input-bairro',
  INPUT_CEP = 'input-cep',
  INPUT_CERTIDAO_OBITO = 'input-certidao-obito',
  INPUT_COMPLEMENTO = 'input-complemento',
  INPUT_DT_RESCISAO = 'input-dt-rescisao',
  INPUT_EMAIL = 'input-email',
  INPUT_ENDERECO = 'input-endereco',
  INPUT_NUMERO = 'input-numero',
  INPUT_TEMPO_CONTRIBUICAO = 'input-tempo-contribuicao',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  LAYOUT_STATUS = 'layout-status',
  LOCATOR_BENEFICIARIOS_EXCLUSAO = 'locator-beneficiarios-exclusao',
  MAPPER_ANEXOS = 'mapper-anexos',
  MAPPER_CIDADE = 'mapper-cidade',
  MAPPER_ESTADO = 'mapper-estado',
  MAPPER_MOTIVO_EXCLUSAO = 'mapper-motivo-exclusao',
  MAPPER_TOAST = 'mapper-toast',
  PANEL_3 = 'panel-3',
  PANEL_ANEXOS = 'panel-anexos',
  PANEL_CARD = 'panel-card',
  PANEL_CONTROL_CARD = 'panel-control-card',
  PANEL_EXCLUSAO_BENEFICIARIO = 'panel-exclusao-beneficiario',
  PANEL_FORM_REENVIO_SOLICITACAO = 'panel-form-reenvio-solicitacao',
  PANEL_MSG_OPERADORA = 'panel-msg-operadora',
  PANEL_STAMP = 'panel-stamp',
  PHONE_CELULAR = 'phone-celular',
  PHONE_TELEFONE = 'phone-telefone',
  RADIO_GROUP_FORMA_CONTATO = 'radio-group-forma-contato',
  STAMP_SITUACAO_LOTE = 'stamp-situacao-lote',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_AREA_OBSERVACAO = 'text-area-observacao',
  TEXT_CIDADE = 'text-cidade',
  TEXT_ESTADO = 'text-estado',
  TEXT_MOTIVO_EXCLUSAO = 'text-motivo-exclusao',
  TEXT_MOTIVO_REJEICAO = 'text-motivo-rejeicao',
  TEXT_OBSERVACAO_REJEICAO = 'text-observacao-rejeicao',
  TIME_FIELD_0 = 'time-field-0',
  TOAST_NOTIFICATION = 'toast-notification',
  UNBOXED_AUTOCOMPLETE_ESTADO = 'unboxed-autocomplete-estado',
  WIZARD_NOVA_EXCLUSAO = 'wizard-nova-exclusao',
  WIZARD_STEP_ANEXO = 'wizard-step-anexo',
  WIZARD_STEP_COMPLEMENTAR = 'wizard-step-complementar',
  WIZARD_STEP_CONTATO = 'wizard-step-contato',
  WIZARD_STEP_OBITO = 'wizard-step-obito',
  WIZARD_STEP_RESCISAO = 'wizard-step-rescisao',
  WIZARD_STEP_SITUACAO_TRABALHISTA = 'wizard-step-situacao-trabalhista',
}
export { ExclusaoBeneficiarioAliases };
